import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common/models';

export class AllocationViewLoanedEquipmentViewModel {
  loanedPhoneView: AllocationViewLoanedEquipmentViewPhoneViewModel;
  webVisitorBadgeView: AllocationViewLoanedEquipmentViewWebVisitorBadgeViewModel;
}

export class AllocationViewLoanedEquipmentViewPhoneViewModel {
  loanerPhoneId: number;
  manufacturer: string;
  model: string;
  phoneNumber: string;
  returnedLoanerPhone: boolean;
}

export class AllocationViewLoanedEquipmentViewWebVisitorBadgeViewModel {
  returnVisitorBadge: boolean;
  visitorBadgeNumber: string;
  permanentBadge: boolean;
}

export class AllocationViewLoanedEquipmentViewForm {
  public loanedPhoneView: UntypedFormGroup;
  public webVisitorBadgeView: UntypedFormGroup;

  constructor(model: AllocationViewLoanedEquipmentViewModel, fb: UntypedFormBuilder) {
    if (model?.loanedPhoneView) {
      this.loanedPhoneView = fb.group(new AllocationViewLoanedEquipmentViewPhoneViewForm(model?.loanedPhoneView));
    }

    if (model?.webVisitorBadgeView) {
      this.webVisitorBadgeView = fb.group(
        new AllocationViewLoanedEquipmentViewWebVisitorBadgeViewForm(model?.webVisitorBadgeView),
      );
    }
  }
}

export class AllocationViewLoanedEquipmentViewPhoneViewForm {
  constructor(
    modelData: AllocationViewLoanedEquipmentViewPhoneViewModel,
    public loanerPhoneId: ControlProperty<number> = [modelData.loanerPhoneId, []],
    public manufacturer: ControlProperty<string> = [modelData.manufacturer, []],
    public model: ControlProperty<string> = [modelData.model, []],
    public phoneNumber: ControlProperty<string> = [modelData.phoneNumber, []],
    public returnedLoanerPhone: ControlProperty<boolean> = [modelData.returnedLoanerPhone, [Validators.requiredTrue]],
  ) {}
}

function visitorBadgeRequiredValidator(permanentBadge: boolean): Validators | undefined {
  if (!permanentBadge) {
    return Validators.requiredTrue;
  }
}

export class AllocationViewLoanedEquipmentViewWebVisitorBadgeViewForm {
  constructor(
    model: AllocationViewLoanedEquipmentViewWebVisitorBadgeViewModel,
    public returnVisitorBadge: ControlProperty<boolean> = [
      model?.returnVisitorBadge,
      visitorBadgeRequiredValidator(model?.permanentBadge),
    ],
    public visitorBadgeNumber: ControlProperty<string> = [model?.visitorBadgeNumber, []],
    public permanentBadge: ControlProperty<boolean> = model?.permanentBadge,
  ) {}
}
